import { RepositoryUtils } from '../utils/RepositoryUtils';
import {
  EnterpriseType,
  HighSchoolType,
  LanguageQualificationType,
  MajorType, NationType,
  QualificationType, SearchApiResponseType,
  UniversityType
} from '../types/EducationTypes';

const ivyApiDomain = process.env.REACT_APP_IVY_APP_SERVER_API_DOMAIN;

export const searchHighschool = (token: string, keyword: string) => {
  return RepositoryUtils.axiosGet<SearchApiResponseType[]>(
    `${ivyApiDomain}/api/v1/search/high-school?keyword=${keyword}`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const searchMajor = (token: string, keyword: string) => {
  return RepositoryUtils.axiosGet<SearchApiResponseType[]>(
      `${ivyApiDomain}/api/v1/search/major?keyword=${keyword}`,
      { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const searchUniversity = (token: string, keyword: string, isGraduated: boolean) => {
  return RepositoryUtils.axiosGet<SearchApiResponseType[]>(
      `${ivyApiDomain}/api/v1/search/university?keyword=${keyword}&includeGraduateSchool=${isGraduated}`,
      { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const searchEnterprise = (token: string, keyword: string) => {
  return RepositoryUtils.axiosGet<EnterpriseType[]>(
      `${ivyApiDomain}/api/v1/search/enterprise?keyword=${keyword}`,
      { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const searchQualification = (token: string, keyword: string) => {
  return RepositoryUtils.axiosGet<QualificationType[]>(
      `${ivyApiDomain}/api/v1/search/qualification?keyword=${keyword}`,
      { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const searchLanguageQualification = (token: string, keyword: string) => {
  return RepositoryUtils.axiosGet<LanguageQualificationType[]>(
      `${ivyApiDomain}/api/v1/search/language-qualification?keyword=${keyword}`,
      { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const searchNation = (token: string, keyword: string) => {
  return RepositoryUtils.axiosGet<NationType[]>(
      `${ivyApiDomain}/api/v1/search/nation?keyword=${keyword}`,
      { headers: { Authorization: `Bearer ${token}` } },
  );
};
